import { helper } from '@ember/component/helper';

/**
 * Helper that returns the same value but with null/undefined types removed.
 * Useful for type narrowing in templates. This is a type-only operation - no runtime checks.
 *
 * @example
 * {{#if (definite @someValue)}}
 *   {{definite @someValue}} {{!-- TypeScript knows this is not null/undefined --}}
 * {{/if}}
 */
const definite = function <T>(params: [T | null | undefined]): Exclude<T, null | undefined> {
	return params[0] as Exclude<T, null | undefined>;
};

const definiteHelper = helper(definite);

export default definiteHelper;
